import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Component that automatically scrolls to top of page on route change
 * This ensures users always start at the top when navigating to a new page
 */
const ScrollToTop = () => {
    const { pathname } = useLocation();

    // Scroll to top whenever the route changes
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    // This component doesn't render anything
    return null;
};

export default ScrollToTop;
